<template>
  <div class="mt-4">
    <SectionTitle
      class="responsive-section-title"
      content="Información de Artículos y Solicitudes Seleccionados"
      has-line
    />
    <div class="row">
      <div class="pb-4 col-12">
        <CustomCallout
          v-if="!displaySearch"
          class-main="py-3"
          :has-toggle="false"
        >
          <div class="row d-flex justify-content-center">
            <ActionButton
              class="border w-40 btn"
              i="fas fa-file-plus color-primary-1"
              text="Presione aquí para añadir artículo"
              @click="displaySearch = true"
            />
          </div>
        </CustomCallout>
        <FilterManager
          v-if="displaySearch"
          ref="filter"
          v-model="this.filterModel"
          class="rounded mt-1 mb-3"
          :filters="filters"
          :display-advanced="false"
          @fiscalYear="onFiscalYearChanged()"
          @search="onSearch"
        />

        <slot />

        <div
          v-if="requestedItemDetail"
          class="col-12 border-radius--light bg-secondary-13 p-2"
        >
          <validation-observer ref="articleForm">
            <div class="row border-radius--light bg-gray-9 m-1 p-2">
              <div
                class="col-12 col-md-2 mt-2 d-flex justify-content-center align-items-center"
              >
                <p class="font-weight-bold info-text">
                  {{ requestedItemDetail.article.name }}
                </p>
              </div>
              <div class="col-12 col-md-2 mt-2">
                <div class="info-text-title">Número de Item:</div>
                <p class="info-text">
                  {{ requestedItemDetail.itemNumber }}
                </p>
              </div>
              <div class="col-12 col-md-2 mt-2">
                <div class="info-text-title">Cantidad de Artículo:</div>
                <p class="info-text">
                  {{ requestedItemDetail.quantity }}
                </p>
              </div>
              <div class="col-12 col-md-2 mt-2">
                <validation-provider
                  v-slot="{ errors }"
                  rules="min_value:1"
                  :custom-messages="{
                    min_value: 'El precio del artículo debe ser mayor a 0.',
                  }"
                >
                  <div class="info-text-title">Precio por Artículo:</div>
                  <div class="align-self-center">
                    <CustomInput
                      v-model="requestedItemDetail.price"
                      type="number"
                      class="height-fixed"
                      :min="0"
                      :error="errors[0]"
                      @input="calcTotalPrice"
                    />
                  </div>
                </validation-provider>
              </div>
              <div class="col-12 col-md-2 mt-2">
                <div class="info-text-title">Monto Total:</div>
                <p class="info-text">
                  {{ requestedItemDetail.amount | price }}
                </p>
              </div>
              <div
                class="col-12 col-md-2 mt-2 d-flex justify-content-center align-items-center"
              >
                <CustomCheckbox
                  text="Seleccionar todos"
                  class="info-text-title"
                  @input="(val) => onSelectAll(val)"
                />
              </div>
            </div>
          </validation-observer>
          <CustomSeparator
            text="Listado de Solicitudes"
            class="my-3 custom-separator-line"
          />
          <div class="row vertical-auto-scroll">
            <ResultRow
              v-for="(item, i) in requestedItemDetail.articles"
              :key="`row-item-$${i}`"
              ref="resultRow"
              :value="item"
              :checked="isItemChecked(item)"
              :item-modified-quantity="itemQuantity(item)"
              @onChecked="onChecked"
              @onModifiedQuantityChanged="onModifiedQuantityChanged"
            />
          </div>
          <div class="col-md-12 col-sm-12 p-0 buttons-container text-right">
            <ActionButton
              class="m-1"
              text="Cancelar"
              variant="outline-danger mr-2"
              i="fa fa-times-circle"
              @click="cancelSelection()"
            />
            <ActionButton
              class="m-1"
              text="Añadir"
              variant="success"
              i="fas fa-file-plus"
              @click="confirmSelection()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import SectionTitle from 'SectionTitle';
import FilterManager from 'FilterManager';
import CustomCallout from 'custom-callout';
import CustomSeparator from 'custom-separator';
import CustomCheckbox from 'CheckBox';
import CustomInput from 'CustomInput';
import ResultRow from './ResultRow';
import academicService from '@/services/api/academicUtils.api.js';
import alert from '@/mixin/alert.mixin';
import {
  getRequestedItems,
  getRequestedItemsDetail,
} from '@/modules/materials-equipment/api';
import { price } from '@/utils/filters';

export default {
  name: 'DetailMaterialsEquipmentRequisition',
  components: {
    ActionButton,
    SectionTitle,
    FilterManager,
    CustomCallout,
    CustomSeparator,
    CustomCheckbox,
    CustomInput,
    ResultRow,
  },
  filters: { price },
  mixins: [alert],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Manejo de Requisición de Materiales y Equipos',
        routes: [
          'Inicio',
          'PEI',
          'Manejo de Requisición de Materiales y Equipos',
        ],
      },
      filterModel: {
        fiscalYear: null,
        item: null,
      },
      displaySearch: false,
      requestedItemDetail: null,
      collections: {
        fiscalYears: [],
        requestedItems: [],
      },
      selectedRequests: [],
      addedItems: [],
      allSelected: false,
    };
  },
  computed: {
    isItemChecked() {
      return (item) =>
        this.selectedRequests.some((t) => t.id === item.id) || this.allSelected;
    },
    itemQuantity() {
      return ({ id }) =>
        this.selectedRequests.find((t) => t.id === id)?.quantityApproved;
    },
    filters() {
      return [
        {
          name: 'fiscalYear',
          component: 'CustomDropDown',
          options: this.collections.fiscalYears,
          placeholder: 'Seleccione el año',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: false,
          class: 'col-md-4',
          classContainer: 'w-100',
          validations: 'required',
          error: 'El año académico es requerido.',
        },
        {
          name: 'item',
          component: 'CustomDropDown',
          options: this.collections.requestedItems,
          placeholder: 'Artículo',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-8',
          classContainer: 'w-100',
          validations: 'required',
          error: 'El artículo es requerido.',
        },
      ];
    },
  },
  async mounted() {
    await this.fetchFiscalYears();
  },
  methods: {
    calcTotalPrice(itemPrice, quantity) {
      const count = quantity || this.requestedItemDetail.quantity;
      this.requestedItemDetail.amount =
        itemPrice || this.requestedItemDetail.price
          ? Number(this.requestedItemDetail.price) * count
          : 0;
    },
    async confirmSelection() {
      const valid = await this.$refs.articleForm.validate();
      if (!valid) {
        return this.$emit(
          'display-alert',
          'Favor de completar la información solicitada para continuar.'
        );
      }

      const quantityRequest = this.selectedRequests.reduce(
        (acc, obj) => (acc += obj.quantityApproved),
        0
      );

      if (!quantityRequest) {
        return this.$emit(
          'display-alert',
          'Favor seleccionar al menos una solicitud.'
        );
      }

      this.calcTotalPrice(null, quantityRequest);
      const data = {
        articles: this.selectedRequests,
        quantity: quantityRequest,
      };

      const itemIdx = this.addedItems.findIndex(
        (i) => i.id == this.requestedItemDetail.id
      );

      if (itemIdx != -1) {
        this.addedItems.splice(itemIdx, 1, {
          ...this.requestedItemDetail,
          ...data,
        });
      } else {
        this.addedItems.push({
          ...this.requestedItemDetail,
          ...data,
          id: this.requestedItemDetail.article?.id,
          name: this.requestedItemDetail.article?.name,
        });
      }

      this.updateSelectedRequest(this.addedItems);
      this.ShowToast(
        'Proceso exitoso',
        'Se han actualizado los datos exitosamente.',
        'success'
      );

      this.cancelSelection();
    },
    onChecked(val, item, modifiedQuantity) {
      if (!val) {
        this.removeFromList(item);
        return;
      }

      this.selectedRequests.push({
        ...item,
        quantityApproved: parseInt(modifiedQuantity ?? item.quantity),
      });
    },
    onModifiedQuantityChanged(item, modifiedQuantity) {
      const request = this.selectedRequests.find((obj) => obj.id === item.id);
      request.quantityApproved = Number(modifiedQuantity);
    },
    onSelectAll(val) {
      this.allSelected = val;
      if (!val) {
        this.selectedRequests = [];
      }
    },
    removeFromList(item) {
      this.selectedRequests = this.selectedRequests.filter(
        (t) => t.id != item.id
      );
    },
    updateSelectedRequest(newValue) {
      this.$emit('updateSelectedRequest', newValue);
    },
    updateRequestResultCount(newValue) {
      this.$emit('updateRequestResultCount', newValue);
    },
    async onFiscalYearChanged() {
      this.cancelSelection();
      this.filterModel.item = null;
      await this.fetchRequestedItems(this.filterModel.fiscalYear.id);
    },
    async fetchFiscalYears() {
      const { data } = await academicService.getFiscalYears();
      this.collections.fiscalYears = data;
      if (data != null) {
        this.filterModel.fiscalYear = data[0];
        this.filterModel.fiscalYear = data[0];
        this.fetchRequestedItems(data[0].id);
      }
    },
    async fetchRequestedItems(fiscalYearId) {
      const { data } = await getRequestedItems(fiscalYearId);
      this.collections.requestedItems = data;
    },
    async onSearch() {
      const isValid = await this.$refs.filter.$refs.formValidator.validate();
      if (!isValid) {
        return;
      }
      const itemId = this.filterModel.item.id;
      await getRequestedItemsDetail(
        this.filterModel.fiscalYear.id,
        itemId
      ).then(({ data }) => {
        const item = this.addedItems.find((i) => i.id === itemId);
        this.requestedItemDetail = item
          ? { ...item, quantity: data.quantity, articles: data.articles }
          : data;
        this.selectedRequests = item?.articles || [];
        this.updateRequestResultCount(data.articles.length);
      });
    },
    cancelSelection() {
      this.requestedItemDetail = null;
      this.selectedRequests = [];
      this.allSelected = false;
      this.filterModel.item = null;
      this.$refs.filter.$refs.formValidator.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';

.info-text-title {
  color: map.get($colors, 'gray-6') !important;
  font-size: 1rem;
  font-weight: normal;
}

.info-text {
  color: map.get($colors, 'black');
  font-weight: normal;
  font-size: 1rem;
  size: 1rem;
}
</style>
